import React from "react";
//
import Icon from "./Icon";

export default function Message({ icon, text }) {
  return (
    <div className="message">
      <p>
        <Icon name={icon} large />
      </p>
      <p>{text}</p>
    </div>
  );
}
